import React from 'react';
import { NavLink } from 'react-router-dom';
import { Spring } from 'react-spring/renderprops';
import MediaQuery from 'react-responsive';

import CompanyLogo from 'components/CompanyLogo';
import LinkBuilder from 'helpers/link-builder';
import RatingStarsWidgetEditable from 'components/RatingStarsWidgetEditable';
import RatingStarsWidget from 'components/RatingStarsWidget';
import PanelContainer from 'components/PanelContainer';
import { ANIMATION_TIMEOUT_INOUT } from 'constants/animation.js';

import './styles.css';
import NumberFormat from 'react-number-format';

const FirmItem = props => {
  const {
    item,
    actions: {
      handleRatingUpdate,
      handleBeforeRatingUpdate,
      onClickEmployeeHandler,
    },
  } = props;

  const {
    Avg,
    Logo = null,
    FirmName,
    UrlAlias,
    TypeName,
    CandidateRating,
    Rating,
    RatingCount,
    ReviewCountSum,
    EmployeeCount,
  } = item;

  const companyLink = LinkBuilder.getFirmLink(UrlAlias);

  const responseText = Number(RatingCount) ? (
    <>
      <NumberFormat
        thousandSeparator
        value={RatingCount}
        displayType={'text'}
      />{' '}
      {Number(RatingCount) === 1 ? 'response' : 'responses'}
    </>
  ) : (
    'No responses'
  );

  const onRatingUpdate = value => {
    handleRatingUpdate(item, value);
  };

  return (
    <Spring
      from={{ opacity: 0 }}
      to={{ opacity: 1 }}
      config={{ duration: ANIMATION_TIMEOUT_INOUT }}
    >
      {props => (
        <div style={props}>
          <PanelContainer styles={{ padding: 0 }}>
            <article className="firm-item">
              <MediaQuery query="(min-width: 481px)">
                <div className="firm-item__container">
                  <div className="firm-item__logo">
                    <CompanyLogo
                      name={FirmName}
                      logo={Logo}
                      link={companyLink}
                      styles={{
                        width: '110px',
                        height: '110px',
                        fontSize: '0.9286rem',
                      }}
                    />
                  </div>
                  <div className="firm-item__content">
                    <div className="firm-item__top">
                      <NavLink className="firm-item__title" to={companyLink}>
                        {FirmName}
                      </NavLink>

                      <div className="firm-item__type">{TypeName}</div>
                    </div>

                    <div className="firm-item__middle">
                      <div className="firm-item__meta">
                        {Number(ReviewCountSum) > 0 ? (
                          <NavLink
                            className="firm-item__stats"
                            to={companyLink + '/reviews'}
                          >
                            Reviews: {ReviewCountSum}
                          </NavLink>
                        ) : (
                          <span className="firm-item__stats firm-item__stats-span">
                            Reviews: {ReviewCountSum}
                          </span>
                        )}
                        <span
                          className="firm-item__stats"
                          onClick={e => {
                            e.preventDefault();
                            onClickEmployeeHandler(item);
                          }}
                        >
                          Employees: {EmployeeCount}
                        </span>
                      </div>
                    </div>

                    <div className="firm-item__rating">
                      {CandidateRating ? (
                        <RatingStarsWidget
                          value={Rating}
                          size={15}
                          showNumber={false}
                        />
                      ) : (
                        <RatingStarsWidgetEditable
                          value={0}
                          size={15}
                          showNumber={false}
                          onChangeHandler={onRatingUpdate}
                          onBeforeChangeHandler={handleBeforeRatingUpdate}
                        />
                      )}
                      <span className="firm-item__rating-comment">
                        {CandidateRating
                          ? responseText
                          : 'What is your perception of this firm?'}
                      </span>
                    </div>

                    <div className="firm-item__info">
                      {Avg.map((avg, index) => (
                        <span key={index} className="firm-item__text">
                          {`${avg.QuestionName}: ${avg.AnswerName}`}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </MediaQuery>

              <MediaQuery query="(max-width: 480px)">
                <div className="firm-item__container">
                  <div className="firm-item__header">
                    <div className="firm-item__logo">
                      <CompanyLogo
                        name={FirmName}
                        logo={Logo}
                        link={companyLink}
                        styles={{
                          width: '110px',
                          height: '110px',
                          fontSize: '0.9286rem',
                        }}
                      />
                    </div>

                    <div className="firm-item__top">
                      <NavLink className="firm-item__title" to={companyLink}>
                        {FirmName}
                      </NavLink>

                      <div className="firm-item__type">{TypeName}</div>

                      <div className="firm-item__meta">
                        <NavLink
                          className="firm-item__stats"
                          to={companyLink + '/reviews'}
                        >
                          Reviews: {ReviewCountSum}
                        </NavLink>
                        <span
                          className="firm-item__stats"
                          onClick={e => {
                            e.preventDefault();
                            onClickEmployeeHandler(item);
                          }}
                        >
                          Employees: {EmployeeCount}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="firm-item__content">
                    <div className="firm-item__rating">
                      {CandidateRating ? (
                        <RatingStarsWidget
                          value={Rating}
                          size={15}
                          showNumber={false}
                        />
                      ) : (
                        <RatingStarsWidgetEditable
                          value={0}
                          size={15}
                          showNumber={false}
                          onChangeHandler={onRatingUpdate}
                          onBeforeChangeHandler={handleBeforeRatingUpdate}
                        />
                      )}
                      <span className="firm-item__rating-comment">
                        {CandidateRating
                          ? responseText
                          : 'What is your perception of this firm?'}
                      </span>
                    </div>

                    <div className="firm-item__info">
                      {Avg.map((avg, index) => (
                        <span key={index} className="firm-item__text">
                          {`${avg.QuestionName}: ${avg.AnswerName}`}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </MediaQuery>
            </article>
          </PanelContainer>
        </div>
      )}
    </Spring>
  );
};

export default FirmItem;
